const view_mode_users = [
    "5cce75eb-723b-43cd-9c1e-5a90aafa0599", // weeklyviewmode@aone.com
];

function isViewModeUser(user_uuid) {
    return view_mode_users.includes(user_uuid);
}

export { isViewModeUser, view_mode_users };